import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider, MutationCache, QueryCache } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ApiClientError } from './api/client';
import { showApiError } from './components/common/Toast';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { EditModeProvider } from './contexts/EditModeContext';
import './index.css';

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      // Don't toast 401s — these are expected auth redirects (e.g., /auth/me on login page)
      if (error instanceof ApiClientError && error.status === 401) {
        return;
      }
      // Allow individual queries to suppress the global error toast
      if (query.meta?.suppressErrorToast) {
        return;
      }
      showApiError(error);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      // Show toast for mutation errors (e.g., failed saves)
      showApiError(error);
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <EditModeProvider>
            <App />
          </EditModeProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
